import styles from '../styles/index.module.less';
import { TutorialsButton } from './TutorialsButton';

/** 桌面端一级导航触发器，浮层由父级统一渲染以避免菜单切换闪烁。 */
export function DropdownButton({ active, index, menu, onEnter }) {
  const hasChildren = menu.children?.length > 0;

  return (
    <div className={styles.dropdownTrigger} onMouseEnter={() => onEnter(hasChildren ? index : null)}>
      <TutorialsButton isHovered={active} menu={menu} />
    </div>
  );
}
